
import { Vue, Component, Ref } from 'vue-property-decorator';
import lazyInject from '@/di';
import InsuranceService from '@/services/insurance.service';
import OrderService from '@/services/order.service';
import lookPDFModal from '@/components/pdf/lookPDFModal.vue';

enum SettlementStatus {
  NotTransferred = '未转账',
  TransferSuccess = '转账成功',
  TransferFailed = '转账失败',
  Transferring = '转账中',
}

@Component({
  components: {
    lookPDFModal,
  },
})
export default class EleccertificateDrawer extends Vue {
  @lazyInject(InsuranceService)
  insuranceService!: InsuranceService;

  @lazyInject(OrderService)
  orderService!: OrderService;

  @Ref('lookPDFModal')
  lookPDFModal!: lookPDFModal;

  PolicyStatus = {
    0: '待处理',
    2: '核保成功',
    4: '失败',
  };

  visible = false;

  tableData: any[] = [];

  settlementStatus = '未转账';

  SettlementStatus = SettlementStatus;

  settlementTotalAmount = '';

  formData: any = {};

  loadData() {
    // TODO: 调用接口获取分页数据
    // 根据 this.pagination.current 和 this.pagination.pageSize 请求数据
  }

  init(value?: any) {
    this.visible = true;
    if (value) {
      // this.tableData = data.bill_id;
      const data = {
        amap_order_id: value,
      };
      this.formData = data;
      // this.tableData = data;
      this.getDatel(data);
    }
  }

  async getDatel(val: any) {
    const res = await this.orderService.getAmapOrderPolicyInfo(val);
    console.log(res);
    this.tableData = res.filter((item: any) => {
      console.log(item);
      return Number(item.insurance) !== 0;
    });
  }

  onClose() {
    this.visible = false;
    this.tableData = [];
  }

  getStatusColorClass() {
    switch (this.settlementStatus) {
      case SettlementStatus.NotTransferred:
        return 'status-not-transferred';
      case SettlementStatus.TransferSuccess:
        return 'status-transfer-success';
      case SettlementStatus.TransferFailed:
        return 'status-transfer-failed';
      case SettlementStatus.Transferring:
        return 'status-transferring';
      default:
        return '';
    }
  }

  async lookPdf(item: any) {
    if (item.eleccertificate_add) {
      window.open(item.eleccertificate_add, '_blank');
      // this.lookPDFModal.init(item.eleccertificate_add);
    } else if (item.cert_status === 0 || item.cert_status === 1) {
      const res = await this.orderService.getAmapOrderGetCert({
        raw_id: item.raw_id,
      });
      if (res.status === 'success') {
        window.open(res.url, '_blank');
        // this.lookPDFModal.init(res.url);
      } else {
        this.$message.error(res.msg);
      }
      console.log(res);
      // window.open(res);
    }
  }
  async underWrite(item: any) {
    this.$confirm({
      title: '提示',
      content: '确定核保吗？',
      okText: '确定',
      cancelText: '取消',
      onOk: async () => {
        const res = await this.insuranceService.getAmapUnderWrite({
          raw_id: item.raw_id,
        });
        if (res) {
          this.getDatel(this.formData);
          this.$message.success(res.msg);
        }
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }
}
